import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarDays, Check, ChevronDown, Loader2, MapPin, Megaphone } from "lucide-react";
import BFEventInvite from "./BFEventInvite";
import { errText, fetchMyEvents, regEvent, ron } from "@/lib/bf";

const roD = (x) => new Date(`${x}T12:00:00`).toLocaleDateString("ro-RO");

const Event = ({ e, clients, onReg }) => {
  const [open, setOpen] = useState(false);
  const [inv, setInv] = useState(true);
  const closed = e.closed;
  const full = e.seats > 0 && e.registered >= e.seats;
  return (
    <li className={`bf-ev ${closed ? "is-closed" : ""}`} data-testid={`bf-ev-${e.id}`}>
      <b>{e.name}{closed && <span className="bf-red-tag" data-testid={`bf-ev-closed-${e.id}`}>Închis</span>}{!closed && full && <span className="bf-red-tag">Complet</span>}</b>
      <div className="bf-ev-meta">
        {e.dates && <span><CalendarDays size={13} /> {e.dates}</span>}
        {e.place && <span><MapPin size={13} /> {e.place}</span>}
        {e.deadline && <span>Înscrieri până pe {new Date(`${e.deadline}T12:00:00`).toLocaleDateString("ro-RO")}</span>}
        {e.seats > 0 && <span>{e.registered} / {e.seats} locuri</span>}
      </div>
      {(e.condition || e.min_value > 0) && <p className="bf-ev-cond" data-testid={`bf-ev-cond-${e.id}`}>Condiție: {[e.condition, e.min_value > 0 ? `achiziție minimă ${ron(e.min_value)}${e.pkg_name ? ` din ${e.pkg_name}` : ""}` : ""].filter(Boolean).join(" · ")}{e.from_date ? ` (achiziții ${roD(e.from_date)}${e.to_date ? ` – ${roD(e.to_date)}` : " – azi"})` : ""}</p>}
      {e.desc && <p className="st-hint">{e.desc}</p>}
      <button type="button" className="bf-gate-switch" onClick={() => setOpen(!open)} data-testid={`bf-ev-open-${e.id}`}>Clienții mei înscriși: {e.mine.length} <ChevronDown size={13} /></button>
      <button type="button" className="bf-gate-switch" onClick={() => setInv(!inv)} data-testid={`bf-ev-invite-${e.id}`}><Megaphone size={13} /> Anunță pe WhatsApp și vezi progresul <ChevronDown size={13} /></button>
      {inv && <BFEventInvite e={e} k={clients.map((c) => c.id).join(",")} />}
      {open && (
        <ul className="bf-smove-list">
          {clients.map((c) => {
            const on = e.mine.includes(c.id);
            return (
              <li key={c.id}><button type="button" className={on ? "is-on" : ""} disabled={!on && (closed || full)} onClick={() => onReg(e, c, !on)} data-testid={`bf-ev-reg-${e.id}-${c.id}`}>
                <i>{on && <Check size={13} />}</i><b>{c.salon || "Salon"}</b><small>{[c.city, c.interested ? "interesat" : ""].filter(Boolean).join(" · ")}</small>
              </button></li>
            );
          })}
          {(closed || full) && <li className="st-hint">{closed ? "Înscrierile s-au închis." : "Nu mai sunt locuri libere."}</li>}
        </ul>
      )}
    </li>
  );
};

export default function BFEduEvents({ brand, clients, onChange }) {
  const [evs, setEvs] = useState(null);
  useEffect(() => { setEvs(null); fetchMyEvents(brand).then(setEvs).catch(() => setEvs([])); }, [brand]);
  if (!evs) return <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă evenimentele…</p>;
  if (!evs.length) return <p className="st-hint" data-testid="bf-ev-none">Încă nu sunt evenimente anunțate pentru acest brand.</p>;
  const onReg = (e, c, on) => regEvent(e.id, c.id, on).then(() => {
    setEvs((l) => l.map((x) => (x.id === e.id ? { ...x, mine: on ? [...x.mine, c.id] : x.mine.filter((y) => y !== c.id), registered: x.registered + (on ? 1 : -1) } : x)));
    if (on) onChange(c.id);
    toast.success(on ? `${c.salon} înscris la ${e.name}` : `${c.salon} scos de la ${e.name}`);
  }).catch((er) => toast.error(errText(er, "Nu am putut salva")));
  return <ul className="bf-evs" data-testid="bf-ev-list">{evs.map((e) => <Event key={e.id} e={e} clients={clients} onReg={onReg} />)}</ul>;
}
